import {inject, Injectable} from '@angular/core';

import {CartCommandService} from '@features/sales/application/store/cart/cart-command.service';
import {OrderCommandService} from '@features/sales/application/store/order/order-command.service';
import {PaymentStatus} from '@platform/event-bus/domain/events/payment/payment-status-changed.event';

@Injectable({providedIn: 'root'})
export class OrderSettlementService {
  private readonly cart = inject(CartCommandService);
  private readonly orders = inject(OrderCommandService);

  handleStatus(orderId: string, status: PaymentStatus): void {
    const actions: Record<PaymentStatus, () => void> = {
      [PaymentStatus.IDLE]: () => {},
      [PaymentStatus.PROCESSING]: () => this.handleProcessing(orderId),
      [PaymentStatus.CHECKOUT]: () => this.handleCheckout(),
      [PaymentStatus.SUCCESS]: () => this.handleSucceeded(orderId),
      [PaymentStatus.FAILED]: () => this.handleFailed(orderId),
      [PaymentStatus.ERROR]: () => this.handleError(orderId),
    };

    (actions[status] ?? actions[PaymentStatus.ERROR])();
  }

  private handleProcessing(orderId: string): void {
    this.orders.markProcessing(orderId);
  }

  private handleCheckout(): void {
    this.cart.lock();
  }

  private handleSucceeded(orderId: string): void {
    this.cart.unlock();
    this.orders.settle(orderId);
    this.orders.remove(orderId);
  }

  private handleFailed(orderId: string): void {
    this.cart.unlock();
    this.orders.markFailed(orderId);
  }

  private handleError(orderId: string): void {
    this.cart.lock();
    this.orders.markPending(orderId);
  }
}
